import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useCreateSystemGroupMutation } from '../../api/groupApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import { TextEditor } from '../../components/TextEditor/TextEditor';
import BroadcastToggleField from '../../components/BroadcastToggleField/BroadcastToggleField';
import ChannelsField from '../../components/ChannelsField/ChannelsField';
import TileImageField from '../../components/TileImageField/TileImageField';
import buttons from '../../styles/shared/buttons.module.css';

export default function SystemGroupCreatePage() {
  const navigate = useNavigate();
  const showToast = useToast();

  const [createGroup, { isLoading: isCreating }] = useCreateSystemGroupMutation();
  const [tileFile, setTileFile] = useState(null);

  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: { name: '', terms: '', channels: ['email'], broadcast: true },
  });
  const broadcast = watch('broadcast');
  const name = watch('name');

  const onCreate = async (data) => {
    try {
      await createGroup({
        name: data.name.trim(),
        tileFile,
        terms: data.terms.trim() || undefined,
        channels: data.channels,
        broadcast: data.broadcast,
      }).unwrap();
      showToast('success', 'System notifications', 'System group created.');
      navigate('/admin/system-notifications');
    } catch (err) {
      showToast('error', 'System notifications', errMsg(err, 'Could not create system group.'));
    }
  };

  return (
    <EntityFormPage title="Add system group" backTo="/admin/system-notifications">
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Name</label>
              <InputText id={field.name} className="w-full mb-3" placeholder="Service alerts" {...field} />
            </div>
          )}
        />

        <TileImageField
          file={tileFile}
          onFileChange={setTileFile}
          name={name}
          onError={(msg) => showToast('error', 'System notifications', msg)}
        />

        <Controller
          name="terms"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Terms &amp; conditions</label>
              <TextEditor value={field.value} onTextChange={(e) => field.onChange(e.htmlValue ?? '')} />
            </div>
          )}
        />

        <ChannelsField control={control} broadcast={broadcast} />

        <BroadcastToggleField control={control} setValue={setValue} />

        <p className="textMuted mb-3">
          System groups start <strong>disabled</strong>. Enable from the list once ready.
        </p>

        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isCreating} />
      </form>
    </EntityFormPage>
  );
}
